<template>
  <div>
      <h5 style="font-size: 16px;font-weight: 600;">{{ languageSelect === 0 ? 'ประกาศความเป็นส่วนตัว' : 'Privacy Policy' }}</h5>
      <!-- <p>ท่านจะต้องมีอายุไม่ตำ่กว่า 16 ปีเพื่อเข้าร่วมกิจกรรมนี้</p> -->
      <div class="pa-2" style="overflow-y: auto; border: 1px solid #ccc;">
        <p style="margin-bottom: 0px;font-size: 15px;">
          {{ languageSelect === 0 ? 'นโยบายการคุ้มครองข้อมูลส่วนบุคคล (Privacy Policy)' : 'Privacy Policy' }}
        </p>
        <a href="https://www.ombudsman.go.th/new/user-privacy" style="font-size: 15px;" target="_blank" rel="noopener noreferrer">https://www.ombudsman.go.th/new/user-privacy</a>
        <p style="margin-bottom: 0px;font-size: 15px;">
          {{ languageSelect === 0 ? 'คําประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Notice)' : 'Privacy Notice' }}
        </p>
        <a href="https://www.ombudsman.go.th/new/annunciate-privacy-notice" style="font-size: 15px;" target="_blank" rel="noopener noreferrer">https://www.ombudsman.go.th/new/annunciate-privacy-notice</a>
      </div>
      <div class="mt-2" style="border: 1px solid #ccc;">
        <div class="pa-1 ma-1">
          <v-checkbox
            :on-icon="'mdi-check-circle'"
            :off-icon="'mdi-checkbox-blank-circle-outline'"
            v-model="statusPAPA"
            false-value="ไม่ยินยอม"
            true-value="ยินยอม"
            :rules="rule"
            class="ma-0 pa-0"
          >
            <template v-slot:label>
              <div class="d-flex flex-column my-2">
                <div style="color: rgba(0, 0, 0, 0.87); font-size: 16px; font-weight: 500;">{{ languageSelect === 0 ? 'ยินยอม' : 'Agree' }}</div>
                <p class="ma-0" style="font-size: 11px; line-height: 1.2; color: rgba(0, 0, 0, 0.6);">{{ languageSelect === 0 ? 'ข้าพเจ้าตกลงและยินยอมตามข้อกำหนดและเงื่อนไขของระบบนัดหมายร้องเรียนนี้*' : 'I agree to the terms and conditions of this complaint appointment system*' }}</p>
              </div>
            </template>
          </v-checkbox>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    rule: {
      type: Array,
      default: () => []
    },
    languageSelect: {
      type: Number,
      default: 0
    },
    fieldValue: {
      type: String,
      default: 'ไม่ยินยอม'
    }
  },
  data () {
    return {
      statusPAPA: this.fieldValue || 'ไม่ยินยอม'
    }
  },
  watch: {
    fieldValue (newVal) {
      this.statusPAPA = newVal || 'ไม่ยินยอม'
    },
    statusPAPA (newVal) {
      console.log('------newVal', newVal)
      this.$emit('change', newVal) // ส่งขึ้นไปหาแม่
    }
  },
  async mounted () {
    if (this.statusPAPA) {
      this.statusPAPA = 'ไม่ยินยอม'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Events/PADAFixShopOfficeOmbudsman.vue